import { Repository } from "./adapters/repository";

import * as retrieveCapacity from "./useCases/retrieveCapacity";
import * as retrieveWorkload from "./useCases/retrieveWorkload";
import * as retrieveWorkloadProjects from "./useCases/retrieveWorkloadProjects";
import * as retrieveOccupancy from "./useCases/retrieveOccupancy";
import * as adjustWorkload from "./useCases/adjustWorkload";
import * as adjustCapacity from "./useCases/adjustCapacity";

enum UseCases {
  retrieveCapacity = "retrieveCapacity",
  retrieveWorkload = "retrieveWorkload",
  retrieveWorkloadProjects = "retrieveWorkloadProjects",
  retrieveOccupancy = "retrieveOccupancy",
  adjustWorkload = "adjustWorkload",
  adjustCapacity = "adjustCapacity",
}

interface Core {
  [UseCases.retrieveCapacity]: retrieveCapacity.Interactor;
  [UseCases.retrieveWorkload]: retrieveWorkload.Interactor;
  [UseCases.retrieveWorkloadProjects]: retrieveWorkloadProjects.Interactor;
  [UseCases.retrieveOccupancy]: retrieveOccupancy.Interactor;
  [UseCases.adjustWorkload]: adjustWorkload.Interactor;
  [UseCases.adjustCapacity]: adjustCapacity.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = { repository: Repository };

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveCapacity]: retrieveCapacity.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveWorkload]: retrieveWorkload.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveWorkloadProjects]:
      retrieveWorkloadProjects.createInteractor(dependencies.repository),
    [UseCases.retrieveOccupancy]: retrieveOccupancy.createInteractor(
      dependencies.repository,
    ),
    [UseCases.adjustWorkload]: adjustWorkload.createInteractor(
      dependencies.repository,
    ),
    [UseCases.adjustCapacity]: adjustCapacity.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
